import React, {Component} from 'react';
// import PropTypes from 'prop-types';
import TopImg from '../Shared/TopImg/TopImg';
import ContinueBtn from '../Shared/ContinueBtn/ContinueBtn';

class Yoga extends Component {
    render() {
        const {
            main_html,
            topImg
        } = this.props.pageData.content;

        let htmlContents = '';
        htmlContents = main_html.map((item, index) => {
            return <div className="content__item_wrapper" key={index} dangerouslySetInnerHTML={{__html: item}}/>
        });

        return (
            <div>
                <TopImg
                    source={'/static/images/' + topImg.source}
                    desc={topImg.desc}
                    offset={topImg.offset}
                />

                <div className="report_html__content">
                    {htmlContents}
                </div>

                <ContinueBtn link="/report/colors" txt="Recommended Colors"/>
            </div>
        );
    }
}

export default Yoga;



// WEBPACK FOOTER //
// ./src/components/Report/ReportContent/Yoga/Yoga.js